import React from 'react';
import styled from 'styled-components';

import { Container, Inner } from './Elements';
import { sectionHeadingTypes } from '../types/propTypes';
import { font } from '../consts/style';
import mq from '../style/mq';

const Wrapper = styled.div`
  width: 100%;
  margin-bottom: 6rem;
  ${Inner} {
    display: flex;
    justify-content: center;
    text-align: center;
    .textwrap {
      position: relative;
      span {
        ${font.sectionHeading};
        position: relative;
        z-index: 10;
        &:after {
          content: '';
          height: 3rem;
          width: 100%;
          background: linear-gradient(
            90deg,
            #0a070e 0%,
            #0d1b26 13.8%,
            #0f2c3c 29.9%,
            #11394b 47.9%,
            #124054 68.8%,
            #134357 100%
          );
          position: absolute;
          left: 0;
          bottom: -0.4rem;
          z-index: -1;

          ${mq.tabletSmall`
            height: 2.4rem;
          `}
        }
      }
      img {
        position: absolute;
        width: 140%;
        top: 3.6rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 0;
      }
    }
  }
`;

export default function SectionHeading({ heading, noUnderline }) {
  return (
    <Wrapper noUnderline={noUnderline}>
      <Container>
        <Inner>
          <div className="textwrap">
            <span>{heading}</span>
          </div>
        </Inner>
      </Container>
    </Wrapper>
  );
}

SectionHeading.propTypes = sectionHeadingTypes;
